import React from 'react';
import {Helmet} from 'react-helmet';
import {getOutlet} from 'reconnect.js';
import LoginModal from '../../Components/LoginModal';
import ResetPasswordModal from '../../Components/ResetPasswordModal';
import GlobalSpinner from '../../Components/GlobalSpinner';

export function renderGlobalHtmlHelmet() {
  return (
    <Helmet>
      {/* adobe font */}
      <link rel="stylesheet" href="https://use.typekit.net/vms4goe.css" />

      {/* google font */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link
        href="https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Noto+Sans+TC:wght@100..900&display=swap"
        rel="stylesheet"
      />
    </Helmet>
  );
}

export function renderGlobalModals() {
  return (
    <>
      <LoginModal />
      <ResetPasswordModal />
      <GlobalSpinner />
    </>
  );
}
